<template>
  <div class="whyChooseWarp mainBox wow animate__animated animate__fadeIn">
    <div>为什么选择 YAOKE IOT</div>
    <div>
      依托物联网、云计算、大数据等尖端技术，为实验室安全管控注入强劲动力
    </div>
    <div class="whyChooseGrid">
      <div class="whyChooseItem maria" v-for="(item, index) in whyChooseList" :key="index">
        <OssImg class="whyChooseIcon" :src="item.icon" alt="" />
        <div>{{ item.title }}</div>
        <div>{{ item.subTitle }}</div>
      </div>
    </div>
  </div>

  <!-- 软件系统 -->
  <menus-check class="wow animate__animated animate__fadeIn" style="margin-top: 2rem;"></menus-check>

  <!-- 可视化审批流程 -->
  <div class="mainBox processWrap wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center">
      <div class="text1">可视化审批流程</div>
      <div class="text2">流程透明如镜，审批快人一步</div>
    </div>
    <div class="processList">
      <div class="processGrid">
        <div class="processItem maria" v-for="(item, index) in processList" :key="index">
          <OssImg class="processIcon" :src="item.icon" alt="" />
          <div>{{ item.title }}</div>
        </div>
      </div>
    </div>
    <div class="processInfo">
      <OssImg class="processPic" src="images/pdtSoft9.png" alt="" />
    </div>
    <div class="title" style="text-align: center">
      <div class="text1">专业数据支持</div>
      <div class="text2" style="margin-bottom: 0;">让制度贯彻管理与流程</div>
    </div>
    <OssImg class="processImg" src="images/pdtSoft2.png" />
    <div class="processTags">
      <div class="display_flex maria" v-for="(item, index) in processList2" :key="index">
        <OssImg class="processTagIcon" :src="item.icon" alt="" />
        <text>{{ item.title }}</text>
      </div>
    </div>
  </div>

  <!-- 简单而高效的实验室管理 -->
  <div class="mainBox processWrap wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center;margin-bottom: 32px;">
      <div class="text1">简单而高效的实验室管理</div>
    </div>
    <div class="libraryGrid">
      <div class="libraryItem mariaNoShadow" v-for="(item, index) in libraryList" :key="index">
        <div class="">
          <div class="tag">{{ item.tag }}</div>
          <OssImg class="libraryImg" :src="item.img" alt="" />
        </div>

        <div class="libraryInfo">
          <div>{{ item.title }}</div>
          <div v-html="item.subTitle"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import menusCheck from "./components/menusCheck.vue";
import { WOW } from "wowjs";

onMounted(() => {
  const wow = new WOW();
  wow.init();
});
const whyChooseList = [
  {
    icon: "images/pdtSoftIcon1.png",
    title: "智能数据分析决策",
    subTitle:
      "集资源管理、流程控制、数据监测于一体，实现分类分级、项目信息、基础使用信息一体化管理，实验室管理轻松准确。",
  },
  {
    icon: "images/pdtSoftIcon2.png",
    title: "精准高效风险防控",
    subTitle:
      "基于预设安全阈值与智能算法，实时监测异常行为与风险数据。如违规操作预警、危化品超量存储提醒、环境参数超标报警。",
  },
  {
    icon: "images/pdtSoftIcon3.png",
    title: "灵活定制适配性强",
    subTitle:
      "持用户根据实验室规模、管理流程、行业特性自定义系统模块与功能。可快速适配，满足多样化场景的个性化管理要求。",
  },
  {
    icon: "images/pdtSoftIcon4.png",
    title: "全场景一体化管理",
    subTitle:
      "覆盖实验室综合、危化品全生命周期、安全准入、隐患巡查、资源共享等实验室核心场景，实现 “人、物、环境” 协同管理。",
  },
];

//审批流程
const processList = ref([
  {
    icon: "images/pdtSoftIcon5.png",
    title: "化学品申购取用按类型审核",
  },
  {
    icon: "images/pdtSoftIcon6.png",
    title: "安全检查隐患整改审核",
  },
  {
    icon: "images/pdtSoftIcon7.png",
    title: "资源预约审核",
  },
  {
    icon: "images/pdtSoftIcon7.png",
    title: "分类分级评定",
  },
]);
const processList2 = ref([
  {
    icon: "images/pdtSoftIcon9.png",
    title: "配伍禁忌",
  },
  {
    icon: "images/pdtSoftIcon10.png",
    title: "密度体积换算",
  },
  {
    icon: "images/pdtSoftIcon11.png",
    title: "msds说明书",
  },
  {
    icon: "images/pdtSoftIcon12.png",
    title: "3w+化学品目录",
  },
]);

//实验室管理
const libraryList = ref([
  {
    img: "images/pdtSoft3.png",
    title: "全流程智能管控",
    subTitle: `自动生成标准化电子台账<br />
      支持自定义多级权限策略<br />
      集成温湿度、气体浓度、烟雾等多参数环境传感器<br />
      用标签识别技术，实现库房化学品毫秒级快速盘点<br />`,
    tag: "库房管理",
  },
  {
    img: "images/pdtSoft4.png",
    title: "智能分析决策支持",
    subTitle: `合规化精准管理<br />
      资源共享、在线预约与智能调度<br />
      24 小时监测环境参数及违规操作行为<br />
      提供 PC 端、移动端、智能终端等多平台访问<br />`,
    tag: "实验室信息",
  },
  {
    img: "images/pdtSoft5.png",
    title: "全流程智能管控",
    subTitle: `多维条件精准触发<br />
      告警历史可溯可查<br />
      告警通知与实验室各类设备、系统深度联动<br />
      支持短信、邮件、APP 消息、声光警报、大屏弹窗等方式<br />`,
    tag: "全局告警通知",
  },
]);
</script>

<style lang="scss" scoped>
.whyChooseWarp {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 3.5rem;

  >div:first-child {
    font-size: 2.5rem;
    line-height: 3.5rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }

  >div:nth-child(2) {
    color: #888888;
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 1.875rem;
    text-align: justify;
    margin-bottom: 2.0625rem;
  }

  .whyChooseGrid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1.5rem;

    .whyChooseItem {
      background: #fff;
      width: 100%;
      height: 14.375rem;
      padding: 2.375rem 1rem 0;
      box-sizing: border-box;
      border-radius: 0.5rem;

      .whyChooseIcon {
        width: 3rem;
        height: 3rem;
        margin-bottom: 1rem;
      }

      >div:first-of-type {
        font-weight: bold;
        font-size: 16px;
        color: #424242;
        margin-bottom: 0.5rem;
      }

      >div:nth-of-type(2) {
        font-weight: 500;
        font-size: 0.875rem;
        color: #888888;
        line-height: 1.3125rem;
        text-align: justify;
      }
    }
  }
}

.processWrap {
  margin-bottom: 3.5rem;

  .processList {
    width: 100%;
    margin-bottom: -10px;

    .processGrid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 1.5rem;

      .processItem {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 7.1875rem;
        background: #fff;
        border-radius: 1rem;

        .processIcon {
          width: 3rem;
          height: 3rem;
          margin-bottom: 0.25rem;
        }
      }
    }
  }

  .processInfo {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 3.5rem;

    .processPic {
      width: 60%;
      height: 100%;
    }
  }

  .processImg {
    width: 100%;
    margin-bottom: 1.5rem;
  }

  .processTags {
    width: 100%;
    display: flex;
    gap: 1.5rem;
    padding-right: -1.5rem;

    >div {
      flex: 1;
      border-radius: 1rem;
      background: #fff;
      height: 6rem;

      .processTagIcon {
        width: 4rem;
        height: 4rem;
        margin-right: 1rem;
      }
    }
  }
}

.libraryGrid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;

  .libraryItem {
    flex: 1;
    position: relative;

    .tag {
      position: absolute;
      padding: 0.625rem;
      background: rgba(0, 0, 0, 0.6);
      color: #ffffff;
      font-weight: 500;
      font-size: 0.875rem;
      border-radius: 1rem 0 1rem 0;
      z-index: 999;
    }

    .libraryImg {
      width: 100%;
      height: 18rem;
    }

    .libraryInfo {
      width: 100%;
      height: 10.875rem;
      padding: 1rem;
      box-sizing: border-box;
      background: #fff;
      border-radius: 0 0 1rem 1rem;
      box-shadow: 0px 0px 20px #0000001a;

      >div:first-child {
        color: #424242;
        font-weight: 500;
        font-size: 1rem;
        line-height: 1.375rem;
        margin-bottom: 1rem;
      }

      >div:nth-child(2) {
        color: #888888;
        font-weight: 500;
        font-size: 0.875rem;
        line-height: 1.5rem;
      }
    }
  }
}

// @media(max-width: 768px) {
//   .processInfo {
//     flex-direction: column;

//     .processPic {
//       width: 100% !important;
//     }
//   }

//   .processTags {
//     flex-wrap: wrap;

//     div {
//       min-width: 40vw;
//     }
//   }

//   .libraryGrid {
//     display: block;
//   }
// }</style>
